export default __webpack_public_path__ + "static/media/klogo.d623f661.png";